export const reducerActions = {
  addItemToCart: 'ADD_ITEM_TO_CART',
  removeCartItem: 'REMOVE_CART_ITEM',
  modifyCartItem: 'MODIFY_CART_ITEM',
  setCartItems: 'SET_CART_ITEMS',
  clearCartItems: 'CLEAR_CART_ITEMS'
};

export const sagaActions = {
  changeItemPurchaseAttributes: 'SAGA_CHANGE_ITEM_PURCHASE_ATTRIBUTES',
  addItemToCart: 'SAGA_ADD_ITEM_TO_CART',
  removeCartItem: 'SAGA_REMOVE_CART_ITEM',
  checkout: 'SAGA_CHECKOUT',
  goToCheckout: 'SAGA_GO_TO_CHECKOUT',
  setCartItems: 'SAGA_SET_CART_ITEMS',
};
